/* ==========================================================================
   BERKWELLNESS Landing Pages — Animations & Interactions
   ========================================================================== */

(function () {
  'use strict';

  /* ---------- Scroll Reveal ---------- */
  function initScrollReveal() {
    var reveals = document.querySelectorAll('.landing-reveal');
    if (!reveals.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('landing-reveal--visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -48px 0px' }
    );

    reveals.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ---------- FAQ Smooth Animation ---------- */
  function initFaqAccordion() {
    var items = document.querySelectorAll('.landing-faq__item');
    if (!items.length) return;

    items.forEach(function (details) {
      var summary = details.querySelector('.landing-faq__question');
      var answerWrapper = details.querySelector('.landing-faq__answer');
      if (!summary || !answerWrapper) return;

      // Set initial state
      if (!details.open) {
        answerWrapper.style.maxHeight = '0px';
        answerWrapper.style.opacity = '0';
      } else {
        answerWrapper.style.maxHeight = answerWrapper.scrollHeight + 'px';
        answerWrapper.style.opacity = '1';
      }

      summary.addEventListener('click', function (e) {
        e.preventDefault();

        if (details.open) {
          // Close
          answerWrapper.style.maxHeight = answerWrapper.scrollHeight + 'px';
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              answerWrapper.style.maxHeight = '0px';
              answerWrapper.style.opacity = '0';
            });
          });
          answerWrapper.addEventListener(
            'transitionend',
            function onEnd() {
              details.removeAttribute('open');
              answerWrapper.removeEventListener('transitionend', onEnd);
            },
            { once: true }
          );
        } else {
          // Open
          details.setAttribute('open', '');
          answerWrapper.style.maxHeight = '0px';
          answerWrapper.style.opacity = '0';
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              answerWrapper.style.maxHeight = answerWrapper.scrollHeight + 'px';
              answerWrapper.style.opacity = '1';
            });
          });
        }
      });
    });
  }

  /* ---------- Testimonial Ticker Pause on Hover ---------- */
  function initTestimonialPause() {
    var rows = document.querySelectorAll('.landing-testimonial-row');
    rows.forEach(function (row) {
      var track = row.querySelector('.landing-testimonial-row__track');
      if (!track) return;
      row.addEventListener('mouseenter', function () {
        track.style.animationPlayState = 'paused';
      });
      row.addEventListener('mouseleave', function () {
        track.style.animationPlayState = 'running';
      });
    });
  }

  /* ---------- Init ---------- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initScrollReveal();
      initFaqAccordion();
      initTestimonialPause();
    });
  } else {
    initScrollReveal();
    initFaqAccordion();
    initTestimonialPause();
  }
})();
